import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectVacancy } from '../../selectors/vacancies';
import { VacancyHeader } from './components/VacancyHeader/VacancyHeader';
import { HeaderContainer } from '../Header/HeaderContainer';

export const VacancyHeaderContainer = () => {
  const vacancy = useSelector(selectVacancy);

  return <VacancyHeader title={vacancy?.title} labels={vacancy?.labels} header={<HeaderContainer />} />;
};
